var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-testimonial mt-5"},[_c('div',{staticClass:"card-avatar"},[_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.userPicture}})]),_vm._v(" "),_c('div',{class:'card-body mt-0 pt-0 text-'+_vm.align},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }